/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2025-12-10 09:36:54
 * @LastEditTime: 2026-05-11 10:52:12
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 超合同管控
 * @FilePath     : \icps_fb\src\api\internetSales\supplyManagement\controlSet\exceedContract.vue
 */
<template>
  <el-dialog
    :visible.sync="exceedContractDig"
    width="980px"
    :close-on-click-modal="false"
    @open="openExceedContractSet"
    @close="closeDig" 
  >
    <span slot="title" class="dialog-title">超合同供应管控</span>

    <div class="tabtop" style="width: 380px">
      <div
        v-for="(item, index) in dataTypeList"
        :key="index"
        @click="choose(item.status)"
      >
        <div :class="dataType == item.status ? 'active' : 'text'">
          {{ item.value }}
        </div>
      </div>
    </div>

    <!-- 常规管控策略内容 -->
    <div v-if="dataType == 1">
      <div class="level-control">
        <h4 class="level-title">第一级管控</h4>
        <el-row class="text">
          <el-col :span="5" :offset="2"><span>累计供应总量比例 ≥</span></el-col>
          <el-col :span="3">
            <el-input
              v-model.number="formData.level1SupplyPercent"
              type="number"
              placeholder=""
              style="width: 100px"
            />
          </el-col>
          <el-col :span="10"><span>% 管控（累计供应总量比例=实际产生累计供应量/合同总量）</span></el-col>
        </el-row>
        <el-row class="text" style="margin-top: 12px">
          <el-col :span="5" :offset="2"><span>累计供应总量比例≥</span></el-col>
          <el-col :span="3">
            <el-input
              v-model.number="formData.level1AlertPercent"
              type="number"
              placeholder=""
              style="width: 100px"
            />
          </el-col>
          <el-col :span="10"><span>% 预警（累计供应总量比例=实际产生累计供应量/合同总量）</span></el-col>
        </el-row>
      </div>

      <!-- 第二级管控 -->
      <div class="level-control">
        <h4 class="level-title">第二级管控</h4>
        <el-row class="text">
          <el-col :span="5" :offset="2"><span>累计供应总量比例 ≥</span></el-col>
          <el-col :span="3">
            <el-input
              v-model.number="formData.level2SupplyPercent"
              type="number"
              placeholder=""
              style="width: 100px"
            />
          </el-col>
          <el-col :span="10"><span>% 管控（累计供应总量比例=实际产生累计供应量/合同总量）</span></el-col>
        </el-row>
        <el-row class="text" style="margin-top: 12px">
          <el-col :span="5" :offset="2"><span>累计供应总量比例≥</span></el-col>
          <el-col :span="3">
            <el-input
              v-model.number="formData.level2AlertPercent"
              type="number"
              placeholder=""
              style="width: 100px"
            />
          </el-col>
          <el-col :span="10"><span>% 预警（累计供应总量比例=实际产生累计供应量/合同总量）</span></el-col>
        </el-row>
      </div>

      <!-- 第三级管控 -->
      <div class="level-control">
        <h4 class="level-title">第三级管控</h4>
        <el-row class="text">
          <el-col :span="5" :offset="2"><span>累计供应总量比例 ≥</span></el-col>
          <el-col :span="3">
            <el-input
              v-model.number="formData.level3SupplyPercent"
              type="number"
              placeholder=""
              style="width: 100px"
            />
          </el-col>
          <el-col :span="10"><span>% 管控（累计供应总量比例=实际产生累计供应量/合同总量）</span></el-col>
        </el-row>
        <el-row class="text" style="margin-top: 12px">
          <el-col :span="5" :offset="2"><span>累计供应总量比例≥</span></el-col>
          <el-col :span="3">
            <el-input
              v-model.number="formData.level3AlertPercent"
              type="number"
              placeholder=""
              style="width: 100px"
            />
          </el-col>
          <el-col :span="10"><span>% 预警（累计供应总量比例=实际产生累计供应量/合同总量）</span></el-col>
        </el-row>
      </div>
    </div>

    <!-- 非常规管控策略内容为空 -->
    <div v-else>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="closeDig()">关 闭</el-button>
      <el-button class="bottom_all" @click="saveExceedContractSet">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  querySupplyControlParam,
  updateSupplyControlParam,
} from "@/api/internetSales/supplyManagement.js";

// 定义需要转换的字段列表
const PERCENT_FIELDS = [
  'level1SupplyPercent',
  'level1AlertPercent',
  'level2SupplyPercent',
  'level2AlertPercent',
  'level3SupplyPercent',
  'level3AlertPercent'
];

export default {
  props: {
    exceedContractDig: {
      type: Boolean,
      default: false,
    },
    low: {
      type: Object,
      default: new Object(),
    },
  },
  data() {
    return {
      dataType: 1,
      formData: {
        id: "",
        status: 1,
        createTime: "",
        createUserName: "",
        createUserId: "",
        updateUserId: "",
        updateUserName: "",
        updateTime: "",
        level1SupplyPercent: "",   // 第一级管控比例 (前端存储为百分比数值，如 11)
        level1AlertPercent: "",    // 第一级预警比例
        level2SupplyPercent: "",   // 第二级管控比例
        level2AlertPercent: "",    // 第二级预警比例
        level3SupplyPercent: "",   // 第三级管控比例
        level3AlertPercent: "",    // 第三级预警比例
        controlId: "",
        companyId: null,
      },
      dataTypeList: [
        {
          value: "常规管控策略",
          status: 1,
        },
        {
          value: "非常规管控策略",
          status: 0,
        },
      ],
    };
  },
  methods: {
    closeDig() {
      this.$emit("closeDig");
    },
    
    // 辅助函数：将后端的小数转为前端的百分比数值
    convertToFrontend(data) {
      const newData = { ...data };
      PERCENT_FIELDS.forEach(field => {
        if (newData[field] !== null && newData[field] !== undefined && newData[field] !== "") {
          newData[field] = Number(newData[field]) * 100;
        } else {
          newData[field] = ""; // 或者 null，视具体需求而定，保持与初始状态一致
        }
      });
      return newData;
    },

    // 辅助函数：将前端的百分比数值转为后端的小数
    convertToBackend(data) {
      const newData = { ...data };
      PERCENT_FIELDS.forEach(field => {
        if (newData[field] !== null && newData[field] !== undefined && newData[field] !== "") {
          newData[field] = Number(newData[field]) / 100;
        } else {
          newData[field] = null; // 或者 ""，根据后端要求，通常数字类型传 null 或 0
        }
      });
      return newData;
    },

    saveExceedContractSet() {
      // 1. 转换数据：前端百分比 -> 后端小数
      const backendFormData = this.convertToBackend(this.formData);
      backendFormData.type = 1
      let params = {
        controlId: this.low.id,
        paramType: this.low.controlTypeVal,
        paramData: backendFormData,
      };
      console.log("保存参数", params);
      updateSupplyControlParam(params).then((res) => {
        if (res.code == 1001) {
          this.$message.success("保存成功!");
          this.closeDig();
        }
      });
    },
    
    openExceedContractSet() {
      querySupplyControlParam({
        id: this.low.id,
        controlTypeVal: this.low.controlTypeVal,
      }).then((res) => {
        if (res.code == 1001) {
          const data = res.data.responseData;
          if (data) {
            // 2. 转换数据：后端小数 -> 前端百分比
            const convertedData = this.convertToFrontend(data);
            
            // 合并默认值和接口返回并转换后的值
            this.formData = {
              ...this.$options.data().formData,
              ...convertedData,
            };
          } else {
            this.formData = this.$options.data().formData;
          }
          console.log("初始化表单数据", this.formData);
          this.dataType = 1;
        }
      });
    },
    choose(num) {
      this.dataType = num;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 18px;
  margin: 12px 12px 12px 18px;
}

.text {
  display: flex;
  align-items: center;
}

.level-control {
  margin-bottom: 24px;

  .level-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
    color: #333;
  }
}
</style>